<template>
    <vxe-modal
        v-model="formInput.isShow"
        @close="closeWinEvent"
        :title="formInput.title"
        width="800"
        height="400"
        show-zoom
        resize
        remember
    >
        <template #default>
            <a-tabs v-model:activeKey="activeKey">
                <a-tab-pane key="1" tab="新增绑定">
                    <vxe-form
                        :data="formInput.formData"
                        :rules="formInput.formRules"
                        title-align="right"
                        ref="rForm"
                        title-width="60"
                    >
                        <vxe-form-item
                            title="咚咚AI助理名称"
                            field="assistantName"
                            span="20"
                            title-width="180px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formInput.formData.assistantName"
                                    placeholder="咚咚AI助理名称"
                                    :disabled="formInput.allInputDisable"
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item span="4">
                            <template #default> </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="咚咚AI助理client_id"
                            field="clientId"
                            span="20"
                            title-width="180px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formInput.formData.clientId"
                                    placeholder="请输入咚咚AI助理client_id"
                                    :disabled="formInput.allInputDisable"
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title=""
                            field=""
                            span="4"
                            title-width="0px"
                        >
                            <template #default>
                                <a
                                    href="https://coe.dongfeng-nissan.com.cn/admin/forum/postsPage/postsContent?searcharticle=1556"
                                    target="_blank"
                                    class="client-link"
                                >
                                    获取方法
                                </a>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="咚咚AI助理client_secret"
                            field="clientSecret"
                            span="20"
                            title-width="180px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formInput.formData.clientSecret"
                                    placeholder="请输入咚咚AI助理client_secret"
                                    :disabled="formInput.allInputDisable"
                                ></vxe-input>
                            </template>
                        </vxe-form-item>

                        <vxe-form-item align="center" span="24">
                            <template #default>
                                <div class="form-actions">
                                    <vxe-button
                                        style="margin-top: 20px"
                                        :loading="submitting"
                                        @click="bindAIAssistant"
                                        icon="fa fa-check"
                                        status="primary"
                                        >绑定
                                    </vxe-button>
                                    <a
                                        href="https://coe.dongfeng-nissan.com.cn/admin/forum/postsPage/postsContent?searcharticle=1558"
                                        target="_blank"
                                        class="client-link"
                                    >
                                        将Dify流程绑定到AI助理方法
                                    </a>
                                </div>
                            </template>
                        </vxe-form-item>
                    </vxe-form>
                </a-tab-pane>
                <a-tab-pane key="2" tab="绑定列表">
                    <div style="overflow: hidden; height: 100%">
                        <vxe-table
                            stripe
                            class="mytable-scrollbar"
                            :data="tableDataHis"
                            :height="220"
                            show-overflow
                            :row-config="{
                                height: 36,
                                isHover: true,
                                isCurrent: true,
                            }"
                            ref="xTableHis"
                        >
                            <vxe-column
                                type="seq"
                                field="Id"
                                title="序号"
                                width="50"
                            ></vxe-column>
                            <vxe-column field="" title="解绑" width="80"
                                ><template #default="{ row }">
                                    <vxe-button
                                        type="text"
                                        icon="fa fa-unlink"
                                        @click="unBinding(row)"
                                    ></vxe-button> </template
                            ></vxe-column>
                            <vxe-column
                                field="assistantName"
                                title="咚咚AI助理名称"
                                width="150"
                                show-overflow
                                resizable
                                sortable
                            >
                            </vxe-column>
                            <vxe-column
                                field="clientId"
                                title="client_id"
                                width="120"
                                show-overflow
                                resizable
                            ></vxe-column>
                            <vxe-column
                                field="clientSecret"
                                title="client_secret"
                                width="140"
                                show-overflow
                                resizable
                            ></vxe-column>
                            <vxe-column
                                field="difyAPISecret"
                                title="Dify接口密钥"
                                width="130"
                                show-overflow
                                resizable
                            ></vxe-column>
                            <vxe-column
                                field="app_type"
                                title="应用类型"
                                width="100"
                            ></vxe-column>
                            <vxe-column
                                field="creationTime"
                                title="创建时间"
                                width="120"
                                show-overflow
                                resizable
                                :formatter="formatTime"
                            ></vxe-column>
                        </vxe-table>
                    </div>
                </a-tab-pane>
            </a-tabs>
        </template>
    </vxe-modal>
</template>

<script setup>
import {
    onMounted,
    reactive,
    ref,
    getCurrentInstance,
    defineExpose,
    defineEmits,
    nextTick,
} from "vue";
import { VXETable } from "vxe-table";
import Qs from "qs";

const { proxy } = getCurrentInstance();
const activeKey = ref("1");
const tableDataHis = ref([]);
const formInput = reactive({
    title: "咚咚AI助理配置",
    isShow: false,
    formData: {
        Id: "",
        publishId: "",
        app_id: "",
        assistantName: "",
        clientId: "",
        clientSecret: "",
        difyAPISecret: "",
        domain: "",
    },
    formRules: {
        assistantName: [{ required: true, message: "咚咚AI助理名称不能为空" }],
        clientId: [{ required: true, message: "咚咚AI助理client_id不能为空" }],
        clientSecret: [
            { required: true, message: "咚咚AI助理client_secret不能为空" },
        ],
    },
});

let submitting = ref(false);
let isViewFooter = ref(true);
let editType = ref("1");
const rForm = ref(null);
const emit = defineEmits(["flashIndex"]);

const closeWinEvent = () => {
    emit("flashIndex");
};
//新增
const addAIAssistant = async (row) => {
    formInput.formData = {
        Id: 0,
        publishId: row.Id,
        app_id: row.otherAppID,
        assistantName: "",
        clientId: "",
        clientSecret: "",
        difyAPISecret: "",
        domain: "",
    };
    editType.value = "1"; //新增
    submitting.value = false;
    activeKey.value = "1";
    formInput.isShow = true;
    const $rForm = rForm.value;
    await nextTick(); // 等待 vxe-form 渲染完成
    getBindAssistantList();
    if (rForm.value) {
        await rForm.value.clearValidate();
    }
};
const getModel = () => {
    const data = {
        Id: formInput.formData.Id,
        app_id: formInput.formData.app_id,
        publishId: formInput.formData.publishId,
        clientId: formInput.formData.clientId,
        clientSecret: formInput.formData.clientSecret,
        assistantName: formInput.formData.assistantName,
    };

    return data;
};
//绑定AI助理
const bindAIAssistant = async () => {
    const $rForm = rForm.value;
    const formErrMap = await $rForm.validate();
    if (formErrMap) {
        submitting.value = false;
        return;
    }
    const type = await VXETable.modal.confirm("您确定要绑定该数据吗?");
    if (type === "confirm") {
        const data = getModel();
        submitting.value = true;
        proxy.$api.newPublishManageAPI
            .bindDifyAIAssistant(Qs.stringify(data))
            .then((res) => {
                if (res.data.Success === false) {
                    let err_msg = "";
                    try {
                        err_msg = JSON.parse(res.data.Message);
                        err_msg = Object.entries(err_msg)
                            .map(([key, val]) => `${key}: ${val}`)
                            .join(", ");
                    } catch {
                        err_msg = res.data.Message;
                    }

                    VXETable.modal.message({
                        content: err_msg,
                        status: "error",
                    });
                    submitting.value = false;
                    return;
                }
                VXETable.modal.message({
                    content: "绑定成功",
                    status: "success",
                });
                getBindAssistantList();

                submitting.value = false;
            })
            .catch((error) => {
                VXETable.modal.message({ content: error, status: "error" });
                submitting.value = false;
                console.log(error);
            });
    }
};

const getBindAssistantList = () => {
    const params = {
        uid: proxy.$store.state.userID,
        email: proxy.$store.state.email,
        currentPage: 0,
        pageSize: 10,
        searchKey: [formInput.formData.publishId],
    };
    proxy.$api.newPublishManageAPI
        .getDifyAIAssistantList(Qs.stringify(params))
        .then((res) => {
            if (res.data.Success) {
                tableDataHis.value = res.data.Data.dataTable;
            }
        });
};

const unBinding = async (row) => {
    const type = await VXETable.modal.confirm("您确定要解绑该数据吗?");
    if (type === "confirm") {
        const data = {
            Id: row.Id,
            app_id: row.app_id,
            publishId: "",
            clientId: row.clientId,
            clientSecret: row.clientSecret,
            assistantName: "",
            api_key: row.difyAPISecret,
        };
        proxy.$api.newPublishManageAPI
            .unbindDifyAIAssistant(Qs.stringify(data))
            .then((res) => {
                if (res.data.Success === false) {
                    let err_msg = "";
                    try {
                        err_msg = JSON.parse(res.data.Message);
                        err_msg = Object.entries(err_msg)
                            .map(([key, val]) => `${key}: ${val}`)
                            .join(", ");
                    } catch {
                        err_msg = res.data.Message;
                    }
                    VXETable.modal.message({
                        content: err_msg,
                        status: "error",
                    });
                    submitting.value = false;
                    return;
                }
                VXETable.modal.message({
                    content: "解绑成功",
                    status: "success",
                });
                getBindAssistantList();
            })
            .catch((error) => {
                VXETable.modal.message({ content: error, status: "error" });
                submitting.value = false;
                console.log(error);
            });
    }
};
defineExpose({ addAIAssistant });
</script>

<style lang="scss" scoped>
.mytable-style .vxe-body--column.col-red {
    background-color: red;
    color: #fff;
}

.active {
    color: green;
}

.error {
    color: red;
}

.audit {
    color: blue;
}
.client-link {
    color: #409eff; /* 默认蓝色 */
    text-decoration: underline;
    cursor: pointer;
    transition: color 0.2s;
}

.client-link:hover {
    color: #337ecc; /* 悬停时加深 */
}
.form-actions {
    display: flex;
    justify-content: center; /* 按钮居中 */
    align-items: center;
    position: relative; /* 让右侧链接相对于容器定位 */
}

.form-actions .client-link {
    position: absolute;
    right: 0; /* 靠右对齐 */
    color: #409eff;
    text-decoration: underline;
    transition: color 0.2s;
}

.form-actions .client-link:hover {
    color: #337ecc;
}
</style>

<style type="text/css">
td.vxe-body--column {
    vertical-align: middle;
}
</style>
